import { Modal, Skeleton } from "antd";
import ReusableTable from "../../Reuseable/ReusableTable/ReusableTable";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllocatedCase } from "../../store/allocationSlice";
import { useNavigate } from "react-router-dom";

export const TelecallerPerformanceModal = ({
  params = {},
  open = false,
  setOpen,
}) => {
  const [pagination, setPagination] = useState({ page: 1, page_size: 10 });
  const { allocated_case, allocated_case_loading } = useSelector(
    (state) => state.allocation,
  );
  console.log(
    allocated_case?.data?.results?.allocated_cases,
    "kldjfkldjkfljdkfd",
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const columns = [];

  useEffect(() => {
    if (open) {
      setPagination({ page: 1, page_size: 10 });
      dispatch(
        fetchAllocatedCase({
          ...params,
          page: 1,
          page_size: 10,
        }),
      );
    }
  }, [open, params]);

  const handleTableChange = (page, size) => {
    setPagination({ page, page_size: size });
    dispatch(
      fetchAllocatedCase({
        ...params,
        page,
        page_size: size,
      }),
    );
  };

  const handleRowClick = (record) => {
    setOpen(false);
    navigate(`/allocation/cases/customer-details/${record?.customer_name}`, {
      state: record,
    });
  };

  const baseColumns = [
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      key: "customer_name",
      render: (text) =>
        allocated_case_loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          text || "-"
        ),
    },
    {
      title: "Loan No.",
      dataIndex: "loan_no",
      key: "loan_no",
      render: (text) =>
        allocated_case_loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          text || "-"
        ),
    },
    {
      title: "Product",
      dataIndex: "product",
      key: "product",
      render: (text) =>
        allocated_case_loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          text || "-"
        ),
    },
    {
      title: "POS",
      dataIndex: "odpos",
      key: "odpos",
      render: (text) =>
        allocated_case_loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          Number(text).toFixed(2) || "-"
        ),
    },
    {
      title: "Aging Bucket",
      dataIndex: "bucket",
      key: "bucket",
      render: (text) =>
        allocated_case_loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          text || "-"
        ),
    },
    {
      title: "Amount Overdue",
      dataIndex: "amount_overdue",
      key: "amount_overdue",
      sorter: true,
      render: (text) =>
        allocated_case_loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          Number(text).toFixed(2) || "-"
        ),
    },
    {
      title: "Bank",
      dataIndex: "bank",
      key: "bank",
      render: (text) =>
        allocated_case_loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          text || "-"
        ),
    },
    {
      title: "Branch",
      dataIndex: "branch_name",
      key: "branch_name",
      render: (text) =>
        allocated_case_loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          text || "-"
        ),
    },
    {
      title: "Region",
      dataIndex: "region",
      key: "region",
      render: (text) =>
        allocated_case_loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          text || "-"
        ),
    },
    {
      title: "Languages",
      dataIndex: "languages",
      key: "languages",
      render: (text) =>
        allocated_case_loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          text || "-"
        ),
    },
    {
      title: "Area",
      dataIndex: "area",
      key: "area",
      render: (text) =>
        allocated_case_loading ? (
          <Skeleton.Input size="small" active />
        ) : Array.isArray(text) ? (
          text.length > 0 ? (
            text.join(", ")
          ) : (
            "-"
          )
        ) : (
          text || "-"
        ),
    },
  ];
  const allocatedColumns = [
    ...baseColumns,
    {
      title: "Assigned To",
      dataIndex: "assigned_to",
      key: "assigned_to",
      render: (text) =>
        allocated_case_loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          text || "-"
        ),
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      render: (text) =>
        allocated_case_loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          text || "-"
        ),
    },
    {
      title: "Team Lead",
      dataIndex: "allocated_teamlead",
      key: "allocated_teamlead",
      render: (text) =>
        allocated_case_loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          text || "-"
        ),
    },
    {
      title: "Supervisor",
      dataIndex: "allocated_supervisor",
      key: "allocated_supervisor",
      render: (text) =>
        allocated_case_loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          text || "-"
        ),
    },
  ];

  return (
    <Modal
      footer={false}
      title="Telecaller Performance"
      open={open}
      onCancel={() => setOpen(false)}
      className="action-codes-modal"
      // style={{ width: '100%' }}
    >
      <ReusableTable
        columns={allocatedColumns}
        dataSource={
          allocated_case_loading
            ? Array(5).fill({})
            : allocated_case?.data?.results?.allocated_cases || []
        }
        totalItems={allocated_case?.data?.count || 0}
        CurrentPageNo={pagination.page}
        pageSize={pagination.page_size}
        triggerChange={handleTableChange}
        onRowClick={handleRowClick}
        pointer={true}
      />
    </Modal>
  );
};
